import React from "react";
import { usaImg, hungaryImg, serbiaImg,russiaImg } from "@/assets/data";
import { useLanguageContext } from "@/context";
import { useTranslation } from "react-i18next";
import "../../../../i18n/i18n";

const languages = [
  {
    name: "Serbia",
    code: "sr",
    image: serbiaImg,
  },
  {
    name: "Hungary",
    code: "hu",
    image: hungaryImg,
  },
  {
    name: "English",
    code: "en",
    image: usaImg,
  },
  {
    name: "Russia",
    code: "ru",
    image: russiaImg,
  },
];

const LanguageDropdown = () => {
  const { changeLanguage, language } = useLanguageContext();
  // Find the current language object
  const currentLanguage =
    languages.find((lang) => lang.code === language) || languages[0];

  const { t, i18n } = useTranslation();
  const changeLanguageWithi18 = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div className="hs-dropdown relative inline-flex [--placement:bottom-right]">
      <button
        id="hs-dropdown-with-header"
        type="button"
        className="hs-dropdown-toggle inline-flex h-10 w-10 flex-shrink-0 items-center justify-center gap-2 rounded-full bg-default-100 align-middle text-xs font-medium text-default-700 transition-all hover:text-primary"
      >
        <img
          src={currentLanguage.image}
          width={24}
          height={16}
          alt={`${currentLanguage.name} flag`}
          className="h-4"
        />
        {/* <LuGlobe size={24} /> */}
      </button>
      <div className="hs-dropdown-menu duration mt-2 hidden min-w-[12rem] rounded-lg border border-default-200 bg-white p-2 opacity-0 shadow-md transition-[opacity,margin] hs-dropdown-open:opacity-100 dark:bg-default-50">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => {
              changeLanguageWithi18(lang.code);
              changeLanguage(lang.code);
            }}
            className={`flex w-full items-center gap-x-3.5 rounded px-3 py-2 text-sm transition-all hover:bg-default-100 ${
              lang.code === language ? "bg-primary-100 text-primary-700" : ""
            }`}
          >
            <img
              src={lang.image}
              width={24}
              height={16}
              alt={`${lang.name} flag`}
              className="h-4"
            />
            <span className="align-middle">{lang.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageDropdown;
